import React from 'react';
import { motion } from 'framer-motion';

interface ExperimentLayoutProps {
  title: string;
  summary: string;
  meta?: React.ReactNode;
  children: React.ReactNode;
}

const fadeInUp: import('framer-motion').Variants = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1] } }
};

const ExperimentLayout: React.FC<ExperimentLayoutProps> = ({ title, summary, meta, children }) => {
  return (
  <section className="space-y-8 max-w-6xl mx-auto px-4 sm:px-6 md:px-8">
      <header className="space-y-3">
  <motion.h1 variants={fadeInUp} initial="hidden" animate="visible" className="text-2xl font-semibold text-gradient">
          {title}
        </motion.h1>
  <motion.p variants={fadeInUp} initial="hidden" animate="visible" transition={{ delay: 0.05 }} className="text-sm text-white/60 max-w-prose">
          {summary}
        </motion.p>
        {meta && (
          <div className="flex flex-wrap gap-2 text-[11px] font-medium text-white/50">
            {meta}
          </div>
        )}
        <div className="h-px w-full bg-gradient-to-r from-transparent via-brand-500/30 to-transparent" />
      </header>
      <div className="space-y-8">
        {children}
      </div>
    </section>
  );
};

export default ExperimentLayout;
